import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useTranslation } from "@/i18n/LanguageContext";

export default function ProtectedRoute({ children }) {
  const { status } = useAuth();
  const location = useLocation();
  const t = useTranslation();

  if (status === "loading") {
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <div className="mono-eyebrow">{t("auth.authenticating")}</div>
      </div>
    );
  }
  if (status === "anonymous") {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
